<template>
  <div class="year-main-content">
    <div class="year-top-image" v-bind:style="{ backgroundImage: 'url(' + require('@/assets/' + topImage) + ')' }">
    <div class="year-overlay"><span>2005</span></div>
    </div>
    <div class="view-wrap yr2005">


<FullYearStats fullGames='16' fullCompletions='323' fullAttempts='500' fullYards='3,576' fullPct='64.6' fullTDs='24' fullINTs='15' fullYPG='223.5' fullRating='89.2'></FullYearStats>

  <div class="year-summary-wrapper">
    <div class="triangle-top-left"></div>
    <div class="triangle-bottom-right"></div>
    <div class="year-summary">
    
      <div class="year-summary-text-flex">
      <h1 class="content-headline">A tough year ends on a sour note...</h1>

      <div class="copy-paragraph">

      While Brees put up good numbers for the second year in a row, he wasn't as efficient, throwing fewer touchdowns and more interceptions on way to an 89.2 QB rating.
      <br/><br/>

      The Chargers offensive line had issues keeping Drew clean, allowing 27 sacks, an unfortunate career-high for Brees.<br/><br/>

      The Chargers were already eliminated from playoff contention entering the final regular season game of 2005, but Brees would still get the start over the young draft pick in Rivers. This would prove costly for Drew, who ended up with a torn labrum after trying to corrall a fumbled ball in his own endzone.<br/><br/>

       The Chargers finished the season 9-6, losing five games by 4 points or less, and were once again on the outside looking in.<br/><br/>

       Brees was on the outside looking in as well, having to deal with a promising career called into question by injury. This is where the Saints came in...<br/><br/>


       <VideoExternal button="Video1" vidName="9 for No. 9 - A Champions Journey - Chapter 4" vidUrl="https://youtu.be/_79b2HUu9js">WATCH: 9 for No. 9 - A Champions Journey - Chapter 4: The Injury</VideoExternal>
       <br/><br/>


      </div>

      <div class="copy-paragraph">
        <img :src="require('@/assets/brees-2005-img-in-copy.jpg')" alt="Drew Brees being helped to the sideline after injuring shoulder" style="width:100%;">
      </div>

      </div> <!--end text-flex-->
    </div>
  </div>





<div class="touchdowns-header-wrapper">
  <h1><img src="https://nolaprodigital.com/saints/brees500/images/referee-icon-white.png" alt="Drew Brees 2005 Touchdown Tally"> 2005 TOUCHDOWN TALLY</h1>
</div>



</div>


<TDsByYear :tds="this.tds"></TDsByYear>



<flickity ref="flickity" :options="flickityOptions">
  <div class="carousel-cell"><img :src="require('@/assets/' + image1)" alt="Drew Brees in 2005 - Slide1"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image2)" alt="Drew Brees in 2005 - Slide2"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image3)" alt="Drew Brees in 2005 - Slide3"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image4)" alt="Drew Brees in 2005 - Slide4"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image5)" alt="Drew Brees in 2005 - Slide5"></div>
</flickity>


<div class="year-pagination-wrapper">
  <div class="year-pagination-section year-pagination-prev"><router-link to="/year/2004">«2004</router-link></div>
  <div class="year-pagination-section year-pagination-current">2005</div>
  <div class="year-pagination-section year-pagination-next"><router-link to="/year/2006">2006»</router-link></div>
</div>



    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import StatsFlex from '@/components/StatsFlex.vue'
import Flickity from 'vue-flickity';
import VideoBtn from '@/components/VideoBtn.vue';
import VideoExternal from '@/components/VideoExternal.vue';
import FullYearStats from '@/components/FullYearStats.vue';
import TDsByYear from '@/components/TDsByYear.vue';

import axios from 'axios';

export default {
  name: 'yr2005',
  components: {
    Flickity,
    StatsFlex,
    VideoBtn,
    VideoExternal,
    FullYearStats,
    TDsByYear
  },
  metaInfo: {
    title: 'Drew Brees Stats and Touchdowns from his 2005 season',
    htmlAttrs: {
      lang: 'en'
    }
  },
  data() {
    return {
      tds: {},
      loading: false,
      games: [],
      topImage: "brees-2005-top.jpg",
      image1: "brees-2005-slide-1.jpg",
      image2: "brees-2005-slide-2.jpg",
      image3: "brees-2005-slide-3.jpg",
      image4: "brees-2005-slide-4.jpg",
      image5: "brees-2005-slide-5.jpg",

      flickityOptions: {
            initialIndex: 0,
            prevNextButtons: false,
            pageDots: false,
            resize: true,
            wrapAround: true,
            autoPlay: true

            // any options from Flickity can be used
            }

          } 
        },
  methods: {
    async getTDs() {
      const self = this;
      const response = await axios.get(
        "../../static/td-data.json"
      );
      this.tds = response.data.y2005;
      console.log(this.tds)
    },
    next() {
      this.$refs.flickity.next();
    },

    previous() {
      this.$refs.flickity.previous();
    },
    resize() {
      this.$refs.flickity.resize();
    }
  },

    mounted: function() {
    this.getTDs();

    setTimeout(() => {
    this.$refs.flickity.resize();
    }, 2000)

}
}
</script>

<style>

.year-top-image > img {
	width:100%;
}


@media (max-width:767px;) {
  .year-main-content {
	margin-top:35px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/yr2005.vue